import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ResearchShowcaseGrantPatent extends BaseModel {
  static override constructorName = 'ResearchShowcaseGrantPatent'

  title: string = ''
  file: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(ResearchShowcaseGrantPatent)
